<template>
    <div :class="[ 'player-embed', { 'is-loading': false === playerEmbed } ]">
        <base-loader v-if="false === playerEmbed" />
        <p
            v-else-if="undefined === playerEmbed"
            class="error"
        >
            We couldn't load player. Please contact us or try again later.
        </p>
        <player-embed-script
            :id="trackNo"
            :hash="hash"
            :player-type="playerType"
        />
    </div>
</template>

<script>
import PlayerEmbedScript from '@/components/PlayerEmbedScript';

export default {
    components: {
        PlayerEmbedScript,
    },

    props: {
        playerEmbed: {
            type: [Object, Boolean],
            required: true,
        },
        showHash: {
            type: String,
            required: true,
        },
        playerType: {
            type: String,
            required: true,
        },
        trackNo: {
            type: String,
            default: '1:0',
        },
        playerHash: {
            type: String,
            default: '',
        },
    },

    computed: {
        /**
         * @returns {string} Embed src.
         */
        hash() {
            return 'archive' === this.playerType ? this.playerHash : this.showHash;
        },
    },
};
</script>
